/**
 * Created by dri on 3/9/18.
 */
import * as $ from "jquery";
import * as _ from "lodash";
import {BaseInternalView, BaseInternalViewOptions} from "../_BaseViews";
import {UserGroupCollection} from "../../collections/UserGroups";
import {PermissionCollection} from "../../collections/Permissions";

export interface BaseModifyModalViewOptions extends BaseInternalViewOptions {
    modelId: number;
}


export class BaseModifyModalView extends BaseInternalView {

    modalIdSelector: string;
    userGroupCollection: UserGroupCollection;
    userGroupPermissionsCollections: { [key: number]: PermissionCollection };
    options: BaseModifyModalViewOptions;
    private permissionRowTemplate = _.template(require('../../templates/modals/permissionRow.html'));
    private noPermissionTemplate = _.template(require('../../templates/modals/noPermission.html'));

    constructor(options: BaseModifyModalViewOptions) {
        super(options);
    };

    show() {
        (<any> this.$('#' + this.modalIdSelector)).modal('show');
    }

    hide() {
        (<any> this.$('#' + this.modalIdSelector)).modal('hide');
    }

    setFormSubmitted() {
        this.$('.modal-footer button').addClass('hidden');
        this.$('.modal-footer .error-message').addClass('hidden');
        this.$('.modal-footer .modal-form-spinner').removeClass('hidden');
    }

    setFormError() {
        this.$('.modal-footer button').removeClass('hidden');
        this.$('.modal-footer .error-message').removeClass('hidden');
        this.$('.modal-footer .modal-form-spinner').addClass('hidden');
    }

    getPermissionsDict() {
        var permissions = {};
        _.map(this.$('.permissions-loaded tr'), (groupRow) => {
            var id = _.trim($(groupRow).attr('data-group-id'));
            var perms = [];

            if ($(groupRow).find('.permission-view').is(':checked')) perms.push('view');
            if ($(groupRow).find('.permission-modify').is(':checked')) perms.push('modify', 'delete');

            if (perms.length) {
                permissions[id] = perms;
            }
        });
        return permissions
    }

    handlePermissionsCollectionLoaded(viewFunction, modifyFunction, deleteFunction,) {
        this.$('.permissions-loading').addClass('hidden');
        this.$('.permissions-loaded').removeClass('hidden');

        var rows = [];
        this.userGroupCollection.each((group) => {
            var id = group.get('id');
            if (!this.options.permissionCollection.canModifyUserGroupPermissions(id)) return;

            var checkedView, checkedModifyDelete, disabled = false;

            if (group.get('is_admin') || this.userGroupCollection.length === 1) {
                // Admin teams always have all permissions and are disabled
                checkedView = true;
                checkedModifyDelete = true;
                disabled = true;
            } else if (this.options.modelId && this.userGroupPermissionsCollections[id]) {
                // Only check permissions if the collection was actually loaded (non-admin teams)
                checkedView = this.userGroupPermissionsCollections[id][viewFunction](this.options.modelId);
                checkedModifyDelete = this.userGroupPermissionsCollections[id][modifyFunction](this.options.modelId)
                    && this.userGroupPermissionsCollections[id][deleteFunction](this.options.modelId);
            }

            rows.push(
                this.permissionRowTemplate({
                    id: id,
                    group: group,
                    checkedView: checkedView,
                    disabled: disabled,
                    checkedModifyDelete: checkedModifyDelete,
                })
            )
        });

        if (!rows.length) {
            rows.push(this.noPermissionTemplate())
        }

        this.$('.permissions-loaded tbody').html(rows.join(''));
        (<any> this.$('.permissions-loaded input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();

        setTimeout(() => {
            this.handleAddButtonDisabledState.call(this)
        }, 300);
    }

    handlePermissionChange(e) {
        var target = $(e.currentTarget);
        var checked = target.is(':checked');

        if (checked) {
            if (target.hasClass('permission-modify')) {
                target.parents('tr').find('.permission-view').prop('checked', true).change()
            }
        } else {
            if (target.hasClass('permission-view')) {
                target.parents('tr').find('.permission-modify').prop('checked', false).change()
            }
        }
        this.handleAddButtonDisabledState();
    }

    handleAddButtonDisabledState() {
    }

    canAssignPerms() {
        var canAssignPerms = false;

        if (this.userGroupCollection) {
            if (this.userGroupCollection.isFetching()) {
                this.setButtonsDisabled(true);
                return null;
            }

            // Only allow a new site group to be created if the user can assign permissions
            this.userGroupCollection.each((group) => {
                if (this.options.permissionCollection.canModifyUserGroupPermissions(group.get('id'))) canAssignPerms = true;
            }, this)
        }

        return canAssignPerms;
    }

    setButtonsDisabled(disabled: boolean) {
        this.$('.btn-success').prop('disabled', disabled);
    }

    handleModalShown() {
    }

    handleModalHidden() {
        this.remove();
    }

    getNewPermissionCollection(usergroupId) {
        return new PermissionCollection([], {userGroupId: usergroupId});
    }

    loadPermissionsCollections(orgId, viewFunction, modifyFunction, deleteFunction) {
        this.$('.permissions-loading').removeClass('hidden');
        this.$('.permissions-loaded').addClass('hidden');

        this.userGroupPermissionsCollections = {};
        this.userGroupCollection = new UserGroupCollection([], {organizationId: Number(orgId)});
        var permissionsCollectionDeferreds = [];
        return $.when(this.userGroupCollection.getCollectionFetchPromise())
            .done(() => {
                this.userGroupCollection.each((g) => {
                    var id = g.get('id');

                    // Skip loading permissions for admin teams since they always have all permissions and are disabled
                    if (g.get('is_admin') || this.userGroupCollection.length === 1) {
                        // Create empty permission collection for admin teams to maintain consistency
                        // But don't add to deferreds since we're not actually loading permissions
                        this.userGroupPermissionsCollections[id] = this.getNewPermissionCollection(id);
                    } else {
                        this.userGroupPermissionsCollections[id] = this.getNewPermissionCollection(id);
                        permissionsCollectionDeferreds.push(
                            this.userGroupPermissionsCollections[id].getCollectionFetchPromise()
                        );
                    }
                });

                // Load all the collections (excluding admin teams)
                if (permissionsCollectionDeferreds.length > 0) {
                    $.when.apply($, permissionsCollectionDeferreds)
                        .then(() => {
                            // now handle permission collection loaded
                            this.handlePermissionsCollectionLoaded(
                                viewFunction,
                                modifyFunction,
                                deleteFunction
                            );
                        });
                } else {
                    // If no non-admin teams, handle immediately
                    this.handlePermissionsCollectionLoaded(
                        viewFunction,
                        modifyFunction,
                        deleteFunction
                    );
                }
            });
    }

    loadDashboardPermissions(dashboardId: number, orgId: number) {
        this.$('.permissions-loading').removeClass('hidden');
        this.$('.permissions-loaded').addClass('hidden');

        this.userGroupPermissionsCollections = {};
        this.userGroupCollection = new UserGroupCollection([], {organizationId: Number(orgId)});
        
        return $.when(this.userGroupCollection.getCollectionFetchPromise())
            .then(() => {
                // Single API call to get dashboard permissions for all user groups
                return $.ajax({
                    url: `/api/v1/permissions/dashboard/${dashboardId}?organizationId=${orgId}`,
                    method: 'GET'
                });
            })
            .then((response) => {
                // Process the response and render permissions
                this.handleDashboardPermissionsLoaded(response.userGroups);
            })
            .fail((error) => {
                console.error('Failed to load dashboard permissions:', error);
                this.$('.permissions-loading').addClass('hidden');
                // Fallback to original method if new endpoint fails
                this.loadPermissionsCollections(orgId, 'canViewDashboard', 'canModifyDashboard', 'canDeleteDashboard');
            });
    }

    handleDashboardPermissionsLoaded(userGroupPermissions: any) {
        this.$('.permissions-loading').addClass('hidden');
        this.$('.permissions-loaded').removeClass('hidden');

        var rows = [];
        this.userGroupCollection.each((group) => {
            var id = group.get('id');
            if (!this.options.permissionCollection.canModifyUserGroupPermissions(id)) return;

            var checkedView, checkedModifyDelete, disabled = false;

            if (group.get('is_admin') || this.userGroupCollection.length === 1) {
                // Admin teams always have all permissions and are disabled
                checkedView = true;
                checkedModifyDelete = true;
                disabled = true;
            } else {
                // Use the pre-loaded dashboard permissions
                const perms = userGroupPermissions[id] || {};
                checkedView = perms.canView || false;
                checkedModifyDelete = (perms.canModify && perms.canDelete) || false;
            }

            rows.push(
                this.permissionRowTemplate({
                    id: id,
                    group: group,
                    checkedView: checkedView,
                    disabled: disabled,
                    checkedModifyDelete: checkedModifyDelete,
                })
            )
        });

        if (!rows.length) {
            rows.push(this.noPermissionTemplate())
        }

        this.$('.permissions-loaded tbody').html(rows.join(''));
        (<any> this.$('.permissions-loaded input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();

        setTimeout(() => {
            this.handleAddButtonDisabledState.call(this)
        }, 300);
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/modals/_BaseModifyModal.ts